import React, { useEffect, useState } from "react";
import { Col, Container, Offcanvas, Row } from "react-bootstrap";
import ContentSection from "./content_section/ContentSection";
import SideFilter from "./side_filter/SideFilter";
import "./DoctorConsultation.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faFilter } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllSpecializationCategory,
  getAllSpecializationCatWSub,
} from "../../features/master/masterSlice";
import { Navigate, useNavigate } from "react-router-dom";
import { resetDoctorFilter } from "../../features/doctor/doctorSlice";
export default function DoctorConsultation() {
  const [showFilter, setShowFilter] = useState(false);

  const dispatch = useDispatch();

  const specializationCatWithSub = useSelector(
    (state) => state.master.specializationCatWithSub,
  );
  useEffect(() => {
    dispatch(getAllSpecializationCatWSub({}));
    dispatch(getAllSpecializationCategory({}));
  }, [dispatch]);

  // reset filters when leaving the doctor consultation page
  useEffect(() => {
    return () => {
      dispatch(resetDoctorFilter());
    };
  }, [dispatch]);

  const navigate = useNavigate();

  return (
    <section className="DoctorConsultation-section">
      <Container>
        <div className="back_holder" onClick={() => navigate(-1)}>
          <FontAwesomeIcon icon={faArrowLeft} className="back_icon" />
          <span>Back</span>
        </div>
        <Row>
          <Col lg={3}>
            <div className="mobile_filter" onClick={() => setShowFilter(true)}>
              <FontAwesomeIcon icon={faFilter} className="filter" />
              <p className="in_text">Filter</p>
            </div>

            <div className="desktop_filter">
              <SideFilter category={specializationCatWithSub} />
            </div>
          </Col>

          <Col lg={9}>
            <ContentSection />
          </Col>
        </Row>
      </Container>
      <Offcanvas
        show={showFilter}
        onHide={() => setShowFilter(false)}
        placement="start"
        className="filter_offcanvas"
      >
        <Offcanvas.Header closeButton>
          <div className="logo_holder">
            <img
              src="/assets/images/logo/redlottus-logo.png"
              className="offcanvaslogo_img"
              alt="logo"
            />
          </div>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <SideFilter category={specializationCatWithSub} />
        </Offcanvas.Body>
      </Offcanvas>
    </section>
  );
}
